<template>
  <div class="footer" v-if="!hiden">
    <div class="block" v-if="isShowAi">
      <img class="footer_icon" :src="footer_icon" />
      <div>回答由 AI 生成，内容仅供参考，请仔细甄别。</div>
    </div>
    <span class="mr-24 block" v-if="isShow">© 2025  江苏户传科技有限公司 版权所有</span>
    <!--<span class="block" v-if="isShow">苏ICP备2025202236</span>-->
  </div>
</template>

<script>
import footer_icon from '@/assets/footer_icon.png'
export default {
  props:{
    isShowAi:{
      type: Boolean,
      default: true
    }
  },
  watch:{
    '$route':{
      immediate: true,
      handler(val) {
        if((val.path == '/tankList' || val.path == '/history' || val.path == '/setting') && window.innerWidth < 680){
          this.hiden = true
        }else{
          this.hiden = false
        }
      }
    }
  },
  data() {
    return {
      footer_icon,
      isShow:true,
      hiden:false
    }
  },
  mounted() {
    this.resizeScran()
    window.addEventListener('resize', () => {
      this.resizeScran()
    })
  },
  methods: {
    resizeScran() {
      if(this.$route.path == '/home') return
      if (window.innerWidth < 830) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer_icon{
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.block{
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    text-align: center;
    margin: 16px 0;
  display: flex;
  justify-content: center;
}
.mr-24{
    margin: 0 24px;
}
</style>